/* Rossi Filati: toccando la miniatura di un colore si apre l'ingrandimento su quella foto. */
(function () {
  if (window.__rfZoom) return;
  window.__rfZoom = true;
  var st = document.createElement('style');
  st.textContent = '.variant-item__image-container{cursor:zoom-in}.variant-item__image-container:hover{outline:2px solid currentColor;outline-offset:2px}';
  document.head.appendChild(st);
  function fname(s) { var m = (s || '').match(/([^\/\s?]+\.(?:jpg|jpeg|png|webp))/i); return m ? m[1] : null; }
  document.addEventListener('click', function (e) {
    var box = e.target.closest('.variant-item__image-container'); if (!box) return;
    var img = box.querySelector('img'); if (!img) return;
    var f = fname(img.currentSrc || img.getAttribute('src'));
    var modalImgs = document.querySelectorAll('product-modal img[data-media-id]');
    var target = null;
    for (var i = 0; i < modalImgs.length; i++) { if (fname(modalImgs[i].getAttribute('src')) === f) { target = modalImgs[i]; break; } }
    var opener = document.querySelector('media-gallery .product__media-toggle');
    if (!target || !opener) return;
    // il tema mostra nel modale solo il primo elemento: come fa lui quando cambia variante, porto la foto in cima
    if (target.parentElement) target.parentElement.prepend(target);
    var old = opener.getAttribute('data-media-id');
    opener.setAttribute('data-media-id', target.getAttribute('data-media-id'));
    opener.click();
    setTimeout(function () { opener.setAttribute('data-media-id', old); }, 400);
  });
})();
